import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import Login from './Components/Login/Login';
import UpsellManagement from './Components/SellManagement/UpsellManagement';
import SideNav from './Components/SideNav/SideNav';
import CategoryDetail from './Components/SellManagement/categoryDetail';
import UpsellProductManagement from './Components/Product/UpsellProductManagement';
import UserReservations from './Components/Booking/UserReservations';
import Dashboard from './Components/Dashboard/Dashboard';
import Orders from './Components/Order/Orders';
import OrderDetail from './Components/Order/OrderDetail';
import ProtectedRoute from './ProtectedRoute';
import ProductDetail from './Components/Product/ProductDetail';
import LockManagement from './Components/TTlock/LockManagement';
import AdminManagement from './Components/AdminManagement/AdminManagement';
import PropertyManagement from './Components/Property/PropertyManag';
import PropertyDetail from './Components/Property/PropertyDetail';
import ReservationDetails from './Components/Booking/ReservationDetail';
import UserLeads from './Components/Leads/Leads';
import LeadDetail from './Components/Leads/LeadDetail';
import PropertyUpsales from './Components/Property/PropertyUpsales';
import AdminDetail from './Components/AdminManagement/AdminDetail';

function App() {
  return (
    <>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/upsell"
            element={
              <ProtectedRoute>
                <SideNav>
                  <UpsellManagement />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/category/:id"
            element={
              <ProtectedRoute>
                <SideNav>
                  <CategoryDetail />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <UpsellProductManagement />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/product/:id"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <ProductDetail />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/booking"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <UserReservations />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <Dashboard />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <Orders />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <OrderDetail />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/lock-management"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <LockManagement />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-management"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <AdminManagement />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-detail/:id"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <AdminDetail />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/property-management"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <PropertyManagement />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/propertydetail/:id"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <PropertyDetail />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reservationdetail/:id"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <ReservationDetails />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <UserLeads />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/lead-detail/:id"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <LeadDetail />
                </SideNav>
              </ProtectedRoute>
            }
          />
          <Route
            path="/propertyUpsales/:propertyId"
            element={
              <ProtectedRoute>
                {' '}
                <SideNav>
                  {' '}
                  <PropertyUpsales />
                </SideNav>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
